export default __webpack_public_path__ + "static/media/arrow-right-disabled-xs.694da8cb.svg";